export default __webpack_public_path__ + "static/media/icon-fees.f3fd0650.svg";